<script>
export default {
    name: 'ContentLogoWallBlock',
    props: {
        data: Object,
    },
};
</script>

<template>
    <div class="logo-wall">
        <div class="logo-wall__logos">
            <div class="logo-wall__logo" v-for="(logo, i) in data.logos" v-bind:key="i">
                <a v-bind:href="logo.link.url" v-bind:target="logo.link.target" class="logo-wall__link">
                    <img class="logo-wall__img" v-bind:src="logo.logo.url" v-bind:alt="logo.logo.alt">
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
$shifted-row-width: 10.08rem;

.logo-wall {
    margin: 12rem -10.08rem 12rem 0;
}
.logo-wall__logos {
    display: flex;
    flex-wrap: wrap;
    margin: -2.4rem -3.2rem;
}
.logo-wall__logo {
    flex: 1;
    min-width: 28.8rem;
    max-width: 28.8rem;
    margin: 2.4rem 3.2rem;
    overflow: hidden;
}
.logo-wall__img {
    max-width: 100%;
}
</style>
